<template>
  <el-card>
    <span class="title">课程信息</span>

    <div class="box">
      <el-button
        @click="exportExcel"
        class="question_bank_but"
        size="mini"
        type="primary"
        icon="el-icon-download"
      >
        导出表格数据
      </el-button>
      <el-form :inline="true" ref="form_ref" :model="form">
        <!-- <el-form-item label="校区" prop="class">
          <el-select
            v-model="form.class"
            placeholder="请选择校区"
            style="width:100%;"
          >
            <el-option
              v-for="item in class_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="学生">
          <el-input v-model="form.nickName" placeholder="学生"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="班级" prop="class">
          <el-select
            v-model="form.class"
            placeholder="请选择年级"
            style="width:100%;"
          >
            <el-option
              v-for="item in class_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="onSubmit">搜索</el-button>
        </el-form-item> -->
      </el-form>

      <el-table id="out-table" :data="tableData" class="table" border stripe>
        <el-table-column prop="Time" label="日期"></el-table-column>
        <el-table-column prop="NickName" label="姓名"></el-table-column>
        <el-table-column prop="Grade" label="年级"></el-table-column>
        <el-table-column prop="Class" label="班级"></el-table-column>
        <el-table-column prop="Teacher" label="老师"></el-table-column>
        <el-table-column prop="Course" label="课程"></el-table-column>
        <el-table-column label="操作" min-width="80">
          <template slot-scope="scope">
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="delete_button(scope.$index, scope.row.Id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
      v-if="false"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="100"
      layout="total, sizes, prev, pager, next, jumper"
      :total="50"
    >
    </el-pagination>
  </el-card>
</template>

<script>
// 引入导出Excel表格依赖
import FileSaver from "file-saver";
import XLSX from "xlsx";
import { mapGetters } from "vuex";
import {
  get_classinfoFilter_api,
  delete_classinfo_api,
} from "@/api/select_course.js";
import { getSchool } from "@/api/admin.js";

export default {
  computed: {
    ...mapGetters(["userInfo", "current"]),
  },
  data() {
    return {
      tableData: [],
      form: {},
      class_options: [
        {
          value: "一",
          label: "一",
        },
        {
          value: "二",
          label: "二",
        },
        {
          value: "三",
          label: "三",
        },
        {
          value: "四",
          label: "四",
        },
      ],

      currentPage: 10,
    };
  },

  created() {
    //获取校区
    getSchool().then((res) => {
      if (res.data) {
        res.data.forEach((v) => {
          if (v.Name == this.current) {
            get_classinfoFilter_api(v.Id).then((res) => {
              this.tableData = res.data;
            });
          }
        });
      }
    });
  },

  methods: {
    //定义导出Excel表格事件
    exportExcel() {
      var wb = XLSX.utils.table_to_book(document.querySelector("#out-table"));
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          //设置导出文件名称
          "课程信息.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },

    //搜索
    onSubmit() {},

    //分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },

    //分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },

    //删除
    delete_button(index, id) {
      console.log(index, id);
      this.$confirm("确定删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        lockScroll: false,
      })
        .then(() => {
          delete_classinfo_api(id).then(() => {
            this.tableData.splice(index, 1);
            this.$message.success("删除成功！");
          });
        })
        .catch(() => {
          this.$message.warning("您已取消操作！");
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.el-card {
  margin:16px;
  .title {
      color:#333;
      font-size:20px;
    }
    .box {
        margin-top :30px;
    }

    .el-pagination {
        margin-top:50px;
    }

        .question_bank_but {
       margin-bottom:20px;
    }
}
</style>
